// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.itamodal-inline-1 {
  position: fixed;
  inset: 0;
  background: rgba(15,23,42,.45);
  backdrop-filter: blur(4px);
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
}

.itamodal-inline-2 {
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 24px 60px -16px rgba(15,23,42,.2);
  width: 600px;
  max-width: 94vw;
  max-height: 86vh;
  overflow-y: auto;
}

.itamodal-inline-3 {
  padding: 18px 22px 14px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 2;
  border-radius: 18px 18px 0 0;
}

.itamodal-inline-4 {
  font-family: 'Outfit',sans-serif;
  font-size: 17px;
  font-weight: 700;
}

.itamodal-inline-5 {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  border: none;
  background: #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #64748b;
}

.itamodal-inline-6 {
  padding: 18px 22px 22px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/ITAdmin/ITAModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,0BAA0B;EAC1B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,+CAA+C;EAC/C,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,MAAM;EACN,gBAAgB;EAChB,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":[".itamodal-inline-1 {\n  position: fixed;\n  inset: 0;\n  background: rgba(15,23,42,.45);\n  backdrop-filter: blur(4px);\n  z-index: 100;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.itamodal-inline-2 {\n  background: #fff;\n  border-radius: 18px;\n  box-shadow: 0 24px 60px -16px rgba(15,23,42,.2);\n  width: 600px;\n  max-width: 94vw;\n  max-height: 86vh;\n  overflow-y: auto;\n}\n\n.itamodal-inline-3 {\n  padding: 18px 22px 14px;\n  border-bottom: 1px solid #e2e8f0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  position: sticky;\n  top: 0;\n  background: #fff;\n  z-index: 2;\n  border-radius: 18px 18px 0 0;\n}\n\n.itamodal-inline-4 {\n  font-family: 'Outfit',sans-serif;\n  font-size: 17px;\n  font-weight: 700;\n}\n\n.itamodal-inline-5 {\n  width: 30px;\n  height: 30px;\n  border-radius: 8px;\n  border: none;\n  background: #f1f5f9;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #64748b;\n}\n\n.itamodal-inline-6 {\n  padding: 18px 22px 22px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
